import { Component, Input, OnInit } from '@angular/core';
import { TYPE_IROPS } from '@app/enums/irops.enum';
/**
 * Componente que muestra el título correspondiente a un caso de IROPs (Irregular Operations).
 */
@Component({
    selector: 'title-irops-view',
    templateUrl: './title-irops-view.component.html',
    styleUrls: ['./title-irops-view.component.scss'],
    standalone: false
})
export class TitleIropsViewComponent implements OnInit {
 /** Enum con los tipos de IROPs disponibles */
 typeIrops = TYPE_IROPS;

 /** Título del caso IROPs, por defecto asignado a "DELAYED" */
 @Input() caseTitle = this.typeIrops.DELAYED;
 
 /** Datos adicionales a mostrar en el título */
 @Input() data: string = '';

  constructor() { }

  ngOnInit() {
  }

}
